<template>
  <form v-if="status === 'success'" class="kt-form" @submit.prevent="action($event, query)">
    <kt-form-section class="row">
      <kt-form-group class="col-12">
        <kt-form-label for="category">
          {{ $t('label.category') }}
        </kt-form-label>
        <select id="category_id" class="form-control kt-selectpicker" name="category_id" v-model="query.category_id">
          <option
              v-bind:key="index"
              v-for="(category, index) in categories"
              v-bind:value="category.id"
          >
            {{ category.label }}
          </option>
        </select>
      </kt-form-group>
      <!--        <kt-form-group class="col-sm-6 col-12">-->
      <!--            <kt-form-label for="priority">-->
      <!--                {{ $t('label.priority') }}-->
      <!--            </kt-form-label>-->
      <!--            <select id="priority" class="form-control" name="priority" v-model="query.priority">-->
      <!--                <option-->
      <!--                    v-bind:key="index"-->
      <!--                    v-for="(priority, index) in priorities"-->
      <!--                    v-bind:value="priority.value"-->
      <!--                    :selected="index == 3"-->
      <!--                >-->
      <!--                    {{ priority.name }}-->
      <!--                </option>-->
      <!--            </select>-->
      <!--        </kt-form-group>-->
    </kt-form-section>
    <kt-form-group>
      <kt-form-label for="subject">
        {{ $t('label.subject') }}
      </kt-form-label>
      <kt-form-control
          v-model="query.subject"
          id="subject"
          name="subject"
      >
      </kt-form-control>
    </kt-form-group>
    <kt-form-group>
      <kt-form-label for="content">
        {{ $t('label.content') }}
      </kt-form-label>
      <kt-form-textarea
          rows="5"
          v-model="query.content"
          id="content"
          name="content"
      >
      </kt-form-textarea>
    </kt-form-group>
    <kt-form-group class="mt-5">
      <kt-form-label>
        {{ $t('label.file_attaching') }}
      </kt-form-label>
      <kt-form-label for="file" class="d-block btn btn-secondary btn-wide label-file">
        <kt-icon type="fa" name="paperclip"></kt-icon>
        {{ $t('label.select_file') }}
      </kt-form-label>
      <input
          @change="processFile"
          type="file"
          class="custom-file-upload"
          name="file"
          id="file"
          accept="image/png,.jpg,.jpeg,.zip"
      />
      <ul class="list-group mb-3 mt-3">
        <li class="border-0 px-0 py-1 list-group-item">
          {{ '- ' + $t('label.comment_files_allowed_format') }}
        </li>
      </ul>
    </kt-form-group>
    <kt-form-group class="col-sm-6 col-12 mt-5" v-if="ShowUserSelectOption($can('read', 'ticket'))">
      <kt-form-label for="user">
        {{ $t('label.user') }}
      </kt-form-label>
      <select
          multiple
          id="created_for"
          class="form-control kt-selectpicker"
          name="created_for"
          v-model="query.created_for"
          v-if="usersListStatus='success'"
      >
        <option
            v-bind:key="index"
            v-for="(user, index) in usersSelectable"
            v-bind:value="user.value"
        >
          {{ user.name }}
        </option>
      </select>
    </kt-form-group>

    <kt-form-action class="mt-4">
      <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_button">
        {{ $t('btn.submit') }}
      </button>
    </kt-form-action>
  </form>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import $ from "jquery";
import { i18n } from '@/plugins/i18n';

export default {
  name: "ManageAccessForm",
  props: {
    action: {
      default: function(e, query) {},
      required: true,
    }
  },
  data: () => {
    return {
      query: {
        category_id: null,
        priority: '2',
        subject: null,
        content: null,
        created_for: []
      },
      categories: []
    }
  },
  computed: {
    ...mapGetters('user', [
      'usersSelectable',
      'usersListStatus',
    ]),
    ...mapState('ticket', {
      status: state => state.status,
    }),
    userId() {
      return this.$route.params.hashid
    },
    priorities() {
      return [
        {
          name: this.$t('ticket.priority.low'),
          value: '0',
        },
        {
          name: this.$t('ticket.priority.middle'),
          value: '1',
        },
        {
          name: this.$t('ticket.priority.high'),
          value: '2',
        },
      ]
    }
  },
  watch: {
    status() {
      this.categories = this.$store.state.ticket.categories
      this.afterDispatch()
    },
  },
  methods: {
    ...mapActions('ticket', {
      fetchCategories: 'fetchCategories'
    }),
    actionM(event, query) {
      this.action(event, query)
    },
    afterDispatch() {
      setTimeout(function () {
        $('.kt-selectpicker').selectpicker({
          size: 4,
          liveSearch: true,
          noneResultsText: i18n.t('selectpicker.none_result'),
          selectAllText: i18n.t('selectpicker.select_all'),
          noneSelectedText: i18n.t('selectpicker.nothing_selected')
        })
      }, 1000)
    },
    ShowUserSelectOption(can_manage_ticket) {
      if (this.userId == undefined && can_manage_ticket) {
        return true;
      }
      else {
        return false;
      }

    },
    processFile(e) {
      this.query.file = event.target.files[0]
      let size_validation = this.validateSize(event.target)
      if (size_validation)
        this.validateFormat(event.target)
    },
    validateSize(file) {
      var FileSize = file.files[0].size / 1024 / 1024; // in MB
      if (FileSize > 1) {
        alert(i18n.t('label.comment_files_allowed_size'));
        this.query.file = ''
        $(file).val('');
        return false;
      } else {
        return true;
      }
    },
    validateFormat(file) {
      let jq_file = $(file);
      let file_name = jq_file.val();
      let extension = file_name.replace(/^.*\./, '');
      if (extension === file_name) {
        extension = '';
      } else {
        extension = extension.toLowerCase();
      }

      switch (extension) {
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'zip':
          break;
        default:
          alert(i18n.t('authenticate.input_format_err'));
          this.query.file = ''
          $(file).val('');
      }
    }
  },
  mounted() {
    this.fetchCategories()
  }
}
</script>

<style>

</style>
